module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacy"
    }
  }, [_c('div', {
    staticClass: "body-content"
  }, [_c('terms'), _vm._v(" "), _c('privacyCZUR')], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-be5b553a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be5b553a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/privacy_part/privacy_part.vue
// module id = 445
// module chunks = 10